import * as React from 'react';
import { AxiosResponse } from 'axios';
import { DynamicSelector, dynamicSelectorUtils, SuggestionValue } from 'consumer-components';

import { diagnostics } from 'ui-common';

import InputContainer from '../InputContainer/InputContainer';
import baseRequest from 'login-apis/baseRequest';

const labels = ['display'];

export default class CountySelector extends React.Component<InputProps> {
  getSearchResults = (value: string) => {
    return baseRequest.get('/api/counties', { params: { term: value } }).then(
      (response: AxiosResponse) => {
        const { data }: { data: SuggestionValue[] } = response;

        return dynamicSelectorUtils.mapSuggestionValues(data, labels);
      },
      (err: any) => {
        diagnostics.error(err, { name: 'Error populating dynamic search dropdown' });
      },
    );
  };

  render() {
    const { input, meta, label, placeholder } = this.props;
    const { value } = input;
    const error = meta.touched && meta.error;
    const identifier = placeholder || 'County Selector';

    return (
      <InputContainer error={error} active={meta.active} name={input.name} label={label} identifier={identifier}>
        <DynamicSelector
          value={value}
          hasError={error}
          labels={labels}
          onChange={input.onChange}
          getSearchResults={this.getSearchResults}
        />
      </InputContainer>
    );
  }
}

export const CountySelectorConfig = {
  component: CountySelector,
};
